/** The bulk endpoints accept this many products per call (plan §5.10). */
export const BULK_CHUNK_SIZE = 500;

/** Splits a bulk change list in calls of at most `size`, in order. */
export function chunkChanges<T>(
  list: readonly T[],
  size = BULK_CHUNK_SIZE
): T[][] {
  const chunks: T[][] = [];
  for (let start = 0; start < list.length; start += size)
    chunks.push(list.slice(start, start + size));
  return chunks;
}
